/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespPriceNegotiationToast_displayInfo$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespPriceNegotiationToastLoader_displayInfo$ref: FragmentReference;
export type PdpRespPriceNegotiationToastLoader_displayInfo = {|
  +$fragmentRefs: PdpRespPriceNegotiationToast_displayInfo$ref,
  +$refType: PdpRespPriceNegotiationToastLoader_displayInfo$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespPriceNegotiationToastLoader_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespPriceNegotiationToast_displayInfo",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '310aaa24029eb4f1c7fae8f368b456ef';
module.exports = node;
